<section class="tw-pr-2">
    <ng-container *ngIf="this.menuItem" [ngSwitch]="true">
        <ng-template [ngSwitchCase]="menuItem.isSeparator">
            <div
                class="tw-flex tw-flex-100 tw-justify-center tw-items-center tw-my-[5px]"
                style="border-bottom: 2px solid #e8e8e8"
            ></div>
        </ng-template>

        <ng-container *ngSwitchDefault>
            <a
                pRipple
                *ngIf="menuItem.url"
                [href]="menuItem.disabled ? '#' : menuItem.url || '#'"
                (click)="itemClick($event, index)"
                (mouseenter)="onMouseEnter($event)"
                class="menu-item ripplelink tw-flex tw-basis-auto tw-items-center tw-gap-x-[5px]"
                [ngClass]="{
                    'tw-justify-start': menuItem.label,
                    'tw-justify-center': !menuItem.label
                }"
                [pTooltip]="menuItem.tooltip"
                tooltipPosition="top"
                [attr.tabindex]="!visible ? '-1' : null"
                [attr.target]="menuItem.target"
                [attr.disabled]="menuItem.disabled ? 'disabled' : undefined"
            >
                <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>

                <span
                    *ngIf="menuItem.label"
                    class="tw-flex tw-flex-100"
                    [ngStyle]="{
                        'font-size': menuItem.label
                            ? menuItem.labelSize || '1.25em'
                            : '4.5em',
                        'font-weight': menuItem.bold ? 'bold' : '400'
                    }"
                    >{{ menuItem.label }}</span
                >

                <ng-container
                    *ngTemplateOutlet="rightSideTemplate"
                ></ng-container>
            </a>

            <a
                pRipple
                *ngIf="menuItem.routerLink"
                (click)="itemClick($event, menuItem, index)"
                (mouseenter)="onMouseEnter($event)"
                class="menu-item ripplelink tw-flex tw-basis-auto tw-gap-x-[5px] tw-items-center"
                [ngClass]="{
                    'tw-justify-start': menuItem.label,
                    'tw-justify-center': !menuItem.label
                }"
                [pTooltip]="menuItem.tooltip"
                tooltipPosition="top"
                [routerLink]="menuItem.disabled ? null : menuItem.routerLink"
                routerLinkActive="active-menuitem-routerlink"
                [routerLinkActiveOptions]="
                    menuItem.routerLinkActiveOptions || {}
                "
                [attr.tabindex]="!visible ? '-1' : null"
                [attr.target]="menuItem.target"
                [attr.disabled]="menuItem.disabled ? 'disabled' : undefined"
            >
                <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>

                <span
                    *ngIf="menuItem.label"
                    class="tw-flex tw-flex-100"
                    [ngStyle]="{
                        'font-size': menuItem.label
                            ? menuItem.labelSize || '1.25em'
                            : '4.5em',
                        'font-weight': menuItem.bold ? 'bold' : '400'
                    }"
                    >{{ menuItem.label }}</span>

                <ng-container
                    *ngTemplateOutlet="rightSideTemplate"
                ></ng-container>
            </a>

            <a
                pRipple
                *ngIf="
                    !menuItem.url &&
                    !menuItem.routerLink &&
                    !menuItem.isSeparator
                "
                (click)="itemClick($event)"
                (mouseenter)="onMouseEnter($event)"
                [pTooltip]="menuItem.tooltip"
                tooltipPosition="top"
                href="javascript:void(0);"
                class="menu-item ripplelink tw-flex tw-basis-auto tw-items-center tw-gap-x-[5px]"
                [ngClass]="{
                    'tw-justify-start': menuItem.label,
                    'tw-justify-center': !menuItem.label
                }"
                [attr.tabindex]="!visible ? '-1' : null"
                [attr.target]="menuItem.target"
                [attr.disabled]="menuItem.disabled ? 'disabled' : undefined"
            >
                <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>

                <span
                    *ngIf="menuItem.label"
                    class="tw-flex tw-flex-100"
                    [ngStyle]="{
                        'font-size': menuItem.label
                            ? menuItem.labelSize || '1.25em'
                            : '4.5em',
                        'font-weight': menuItem.bold ? 'bold' : '400'
                    }"
                    >{{ menuItem.label }}</span
                >

                <ng-container
                    *ngTemplateOutlet="rightSideTemplate"
                ></ng-container>
            </a>

            <div class="layout-menu-tooltip">
                <div class="layout-menu-tooltip-arrow"></div>
                <div class="layout-menu-tooltip-text">{{ menuItem.label }}</div>
            </div>

            <ng-container
                *ngIf="
                    this.parentComponent.currentLayout$ | async;
                    let currentLayout
                "
            >
                <ul
                    app-submenu
                    [item]="menuItem"
                    *ngIf="this.menuItem.items"
                    [visible]="this.isActive() | async"
                    [reset]="reset"
                    [parentActive]="
                        this.parentComponent.isActive(index) | async
                    "
                    [@children]="
                        (currentLayout.isSlimMenu ||
                            currentLayout.service.isHorizontalMenu) &&
                        root
                            ? this.isActive()
                                ? 'visible'
                                : 'hidden'
                            : this.parentComponent.isActive()
                            ? 'visibleAnimated'
                            : 'hiddenAnimated'
                    "
                ></ul>
            </ng-container>
        </ng-container>
    </ng-container>
</section>

<ng-template #iconTemplate>
    <div
        [ngStyle]="{
            'font-size': this.menuItem.label
                ? menuItem.iconSize || '1em'
                : '4.5em'
        }"
        class="tw-flex tw-flex-[12%]"
    >
        <ng-container
            *ngIf="this.menuItem.iconTemplate; else defaultIconTemplate"
            [ngTemplateOutlet]="this.menuItem.iconTemplate"
        ></ng-container>
    </div>
</ng-template>

<ng-template #defaultIconTemplate>
    <ng-container *ngIf="menuItem.icon" [ngSwitch]="menuItem.iconType">
        <ng-container *ngSwitchCase="'fontawesome'">
            <em
                [ngStyle]="{
                    'font-size': menuItem.label
                        ? menuItem.iconSize || '1em'
                        : '4.5em'
                }"
                class="menu-item-icon tw-flex tw-flex-[12%] {{ menuItem.icon }} tw-text-blue-400"
            ></em>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <em
                [ngStyle]="{
                    'font-size': menuItem.label
                        ? menuItem.iconSize || '1em'
                        : '4.5em'
                }"
                class="menu-item-icon material-icons"
                >{{ menuItem.icon }}</em
            >
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #rightSideTemplate>
    <section class="tw-flex tw-basis-auto tw-justify-end m-0">
        <ng-container
            *ngIf="this.menuItem.badgeTemplate; else badgeTemplate"
            [ngTemplateOutlet]="this.menuItem.badgeTemplate"
        >
        </ng-container>

        <em class="material-icons submenu-icon" *ngIf="menuItem.items"
            >keyboard_arrow_down</em
        >
    </section>
</ng-template>

<ng-template #badgeTemplate>
    <ng-container *ngIf="menuItem.badgeValue != undefined">
        <div class="tw-flex tw-flex-col tw-relative tw-right-[-34px]">
            <p-badge
                [value]="menuItem.badgeValue"
                [severity]="menuItem.badgeSeverity"
                [size]="menuItem.badgeSize"
            ></p-badge>
        </div>
    </ng-container>
</ng-template>
